var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2904 5.74904C33.8996 4.27389 32.746 3.1121 31.285 2.71847C28.6326 2 18 2 18 2C18 2 7.36741 2 4.71496 2.71465C3.25022 3.10828 2.10045 4.27006 1.7096 5.74522C1 8.42038 1 14 1 14C1 14 1 19.5796 1.7096 22.251C2.10045 23.7261 3.25402 24.8879 4.71496 25.2815C7.36741 26 18 26 18 26C18 26 28.6326 26 31.285 25.2815C32.7498 24.8879 33.8996 23.7261 34.2904 22.251C35 19.5796 35 14 35 14C35 14 35 8.42038 34.2904 5.74904ZM14.6228 19.121V8.87898L23.4263 13.9618L14.6228 19.121Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtb);
export default __webpack_public_path__ + "static/media/UTB.e5acf652.svg";
export { ForwardRef as ReactComponent };